// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.date-saperator {
  margin: 20px 16px 12px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  animation-name: bubbleAnim;
  animation-duration: 0.5s;
  animation-fill-mode: forwards;
  opacity: 0;
}
.date-saperator.date-saperator-1 .line-border {
  display: none;
}
.date-saperator.date-saperator-1 .date-text {
  background: var(--date-seperator-bg);
  border-radius: 32px;
}
.date-saperator.date-saperator-2 .line-border {
  display: none;
}
.date-saperator.date-saperator-2 .date-text {
  border: 1px solid var(--date-seperator-border);
  border-radius: 4px;
  width: 100%;
  padding: 7px 8px;
}
.date-saperator .line-border {
  width: 72px;
  border: 1px solid var(--date-seperator-line-border);
  margin: 0 12px;
}
.date-saperator .date-text {
  font-weight: 600;
  font-size: 12px;
  line-height: 15px;
  color: var(--date-seperator-color);
  padding: 4px 8px;
  position: relative;
  z-index: 1;
  flex-shrink: 0;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/templatemanager/base/misc/dateSeparator/dateSeparator.scss"],"names":[],"mappings":"AAEA;EACI,2BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,0BAAA;EACA,wBAAA;EACA,6BAAA;EACA,UAAA;AADJ;AAGQ;EACI,aAAA;AADZ;AAGQ;EACI,oCAAA;EACA,mBAAA;AADZ;AAKQ;EACI,aAAA;AAHZ;AAKQ;EACI,8CAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;AAHZ;AAMI;EACI,WAAA;EACA,mDAAA;EACA,cAAA;AAJR;AAMI;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kCAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,cAAA;EACA,kBAAA;AAJR","sourcesContent":["// Date Saperator\n\n.date-saperator{\n    margin: 20px 16px 12px 16px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: relative;\n    animation-name: bubbleAnim;\n    animation-duration: 0.5s;\n    animation-fill-mode: forwards;\n    opacity: 0;\n    &.date-saperator-1{\n        .line-border{\n            display: none;\n        }\n        .date-text{\n            background: var(--date-seperator-bg);\n            border-radius: 32px;            \n        }\n    }\n    &.date-saperator-2{\n        .line-border{\n            display: none;\n        }\n        .date-text{\n            border: 1px solid var(--date-seperator-border);\n            border-radius: 4px;\n            width: 100%;  \n            padding: 7px 8px;       \n        }\n    }\n    .line-border{\n        width: 72px;\n        border: 1px solid var(--date-seperator-line-border);\n        margin: 0 12px;\n    }\n    .date-text{\n        font-weight: 600;\n        font-size: 12px;\n        line-height: 15px;\n        color: var(--date-seperator-color);\n        padding: 4px 8px;\n        position: relative;\n        z-index: 1;\n        flex-shrink: 0;\n        text-align: center;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
